module.exports = __webpack_public_path__ + "img/praise.png";